import { http } from "./http.js";

async function getDriver(resource, id) {
  const response = await http.get(`/${resource}/${id === "0" ? "new" : id}`);
  return response;
}

async function updateDriver(resource, id, driver) {
  const response = await http.put(`/${resource}/${id}`, driver);
  return response;
}

async function createDriver(resource, driver) {
  const response = await http.post(`/${resource}`, driver);
  return response;
}

async function changeRemovedState(resource, id, isRemoved) {
  const response = await http.patch(
    `/${resource}/${id}/rpc/change-removed-state`,
    {
      value: !isRemoved,
    },
  );
  return response;
}
export { getDriver, updateDriver, createDriver, changeRemovedState };
